import React from 'react';
import {FormattedMessage} from 'react-intl';
import styles from './RegFormsTitle.module.scss';

const RegFormsTitle = () => {

  return (
    <div className={styles.title}>
      <FormattedMessage
        id={'regForms-page-title'}
        defaultMessage={'Registration forms'}
      />
    </div>
  );
};

export default RegFormsTitle;
